import React from 'react';
import MainHomepage from './MainHomepage';

const WebsiteSelector = () => {
  return <MainHomepage />;
};

export default WebsiteSelector;